module.exports = __webpack_public_path__ + "static/media/curriculumKit__robot.c0d90561.svg";